<template>
  <div v-if="isVisible" class="pokoj">
    <div class="col-12 col-sm-12 col-lg-4 foto">
      <img v-if="room.mainImage" :src="appBase + room.mainImage.urlThumb" class="w-100 img-fluid" :alt="room.name" />
    </div>

    <div class="col-6 col-sm-8 col-lg-4 opis d-flex align-items-center lora">
      <div>
        <p class="h3">{{ room.name }}</p>

        <p v-if="room.area" class="m2" v-html="formatMSquare(room.area)"></p>

        <p v-if="room.importantEquipment" class="plus">{{ room.importantEquipment }}</p>

        <p v-if="room.bedType" class="bad">{{ room.bedType }}</p>

        <p class>
          <a v-if="detailsVisible" class="btn-intryga" @click.stop="toggleDetails">Ukryj</a>

          <a v-else class="btn-intryga" @click.stop="toggleDetails">Czytaj więcej</a>
        </p>
      </div>
    </div>

    <div class="col-6 col-sm-4 col-lg-4 text-right d-flex align-items-center lora">
      <div class="text-right w-100">
        <p v-if="hasMultiplePrices || isOfferSelected" class="cena">
          <span v-if="!isOfferSelected" class="small">od&nbsp;</span>{{ price }}
        </p>

        <button v-if="hasMultiplePrices" type="button" class="btn btn-secondary mb-1" @click.stop="togglePrices">
          <div v-if="pricesVisible" class="btn__content">
            <img src="/content/reservation/img/up.png" alt="ukryj ceny" />
          </div>

          <div v-else class="btn__content">
            Pokaż ceny
            <img src="/content/reservation/img/down.png" alt="pokaż ceny" />
          </div>
        </button>

        <template v-if="isMultiple">
          <button v-if="!isSelected" type="buton" class="btn btn-outline-secondary mb-1 ml-2" @click="selectRoom">
            <div class="btn__content">Wybierz</div>
          </button>

          <button v-else-if="isSelected" type="button" class="btn btn-outline-secondary mb-1 ml-2" @click="unSelectRoom">
            <div class="btn__content_change">Zmień</div>
          </button>
        </template>
      </div>
    </div>

    <div v-if="detailsVisible" class="container-fluid lora">
      <hr />

      <div class="row">
        <div class="col-12 col-md-8">
          <div v-html="details.description"></div>

          <VueGallery :index="galleryIndex" :images="galleryImages" @close="galleryIndex = null" />

          <div class="row gallery">
            <div
              v-for="(photo, index) in details.photos"
              :key="`room_photo_` + index"
              class="col-12 col-sm-6 col-md-3 my-3"
              @click.stop="galleryIndex = index"
            >
              <a>
                <img :src="appBase + photo.urlThumb" alt class="img-fluid" data-original />
              </a>
            </div>
          </div>
        </div>

        <div v-if="details.equipment && details.equipment.length" class="col-12 col-md-4">
          <p class="pb-3">Wyposażenie</p>
          <ul>
            <li v-for="(element, index) in details.equipment" :key="'room_equipment_' + index">{{ element }}</li>
          </ul>
        </div>
      </div>
    </div>

    <div v-if="pricesVisible || (!hasMultiplePrices && !isOfferSelected)" class="container-fluid lora">
      <div v-for="(price, index) in room.prices" :key="'price_index_' + index" class="row promocja border-left">
        <div class="col-12 col-sm-12 col-lg-4 foto">
          <!-- <img src="/content/reservation/img/oferta1-foto.jpg" class="w-100 img-fluid" /> -->
        </div>

        <div class="col-6 col-sm-8 col-lg-5 opis d-flex align-items-start lora">
          <div>
            <p class="h4">{{ price.name }}</p>
            <p v-if="price.description" v-html="price.description"></p>
          </div>
        </div>

        <div class="col-6 col-sm-4 col-lg-3 text-right d-flex align-items-center lora">
          <div class="text-right w-100">
            <p v-if="index === 0" class="small text-info">Najniższa cena</p>

            <p class="cena">{{ formatPrice(price.price) }}</p>

            <button v-if="!isMultiple" type="button" class="btn btn-secondary btn-lg mb-1" @click="selectPrice(price)">
              Rezerwuj
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueGallery from 'vue-gallery';

import roomService from '@/services/room.service';
import { formatPrice } from '@/utils/formatPrice';

export default {
  components: { VueGallery },
  props: {
    room: { type: Object, required: true },
    occupancy: { type: Object },
    schema: { type: Object }
  },
  data() {
    return {
      appBase: process.env.VUE_APP_BASE,
      detailsVisible: false,
      pricesVisible: false,
      details: null,
      galleryIndex: null
    };
  },
  computed: {
    galleryImages() {
      return this.details?.photos?.map(photo => this.appBase + photo.urlLarge);
    },
    price() {
      if (this.occupancy.offer.id.$model) {
        return this.formatPrice(this.occupancy.offer.price.$model);
      }
      const lowestPrice = JSON.parse(JSON.stringify(this.room.prices)).sort((a, b) => a.price - b.price)[0].price;
      return this.formatPrice(lowestPrice);
    },
    isMultiple() {
      return this.schema.occupancy.$items.length > 1;
    },
    hasMultiplePrices() {
      return this.room.prices.length > 1;
    },
    isVisible() {
      const selectedId = this.occupancy.room.id.$model;
      return !selectedId || this.isSelected;
    },
    isSelected() {
      return this.room.id === this.occupancy.room.id.$model;
    },
    isOfferSelected() {
      return !!this.occupancy.offer.id.$model;
    }
  },
  methods: {
    toggleDetails() {
      this.pricesVisible = false;
      if (!this.details) {
        return roomService
          .get(this.room.id, this.schema.dateRange.start.$model, this.schema.dateRange.end.$model)
          .then(details => {
            this.details = details;
            this.detailsVisible = true;
          });
      }
      this.detailsVisible = !this.detailsVisible;
    },
    togglePrices() {
      this.pricesVisible = !this.pricesVisible;
      this.detailsVisible = false;
    },
    formatMSquare(area) {
      if (!area) {
        return;
      }
      return area.replace(/m\^2/gi, 'm&sup2;');
    },
    formatPrice,
    selectRoom() {
      this.occupancy.room.$setData(this.room);
      this.occupancy.additions.$setLength(0);
      this.pricesVisible = false;
      this.detailsVisible = false;
      this.$emit('selected');
    },
    unSelectRoom() {
      this.occupancy.room.$setData({ id: 0, name: '' });
      this.occupancy.offer.$setData({ id: 0, name: '' });
      this.occupancy.additions.$setLength(0);
      this.$emit('unselected');
    },
    selectPrice(price) {
      this.occupancy.offer.$setData(price);
      if (!this.schema.offer.id.$model) {
        this.schema.offer.$setData({ ...price, price: null });
      }
      this.pricesVisible = false;
      this.selectRoom();
    }
  }
};
</script>

<style>
.btn-intryga {
  cursor: pointer;
}
</style>
